// frontend/book-app-frontend/src/components/EditorDashboard.js
import React from 'react';
import { Outlet } from 'react-router-dom';

function EditorDashboard() {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>Editor Dashboard</h1>
      <Outlet />
    </div>
  );
}

export default EditorDashboard;